<template>
    <v-card>
        <v-card-text>
            <UsuarioSearch :loading="fetching" @search="params = $event" />
        </v-card-text>

        <v-card-text>
            <UserList :params="params" :loading.sync="fetching" />
        </v-card-text>
    </v-card>
</template>

<script>
import UserList from '@components/entities/usuario';
import UsuarioSearch from '@components/entities/usuario/search';

export default {
    components: {
        UserList,
        UsuarioSearch,
    },
    props: {},
    data: function () {
        return {
            options: {},
            fetching: false,
            params: {}
        }
    },
    created: function () {
        this.$store.dispatch('ui/layout/setTitle', 'USUARIOS');
    },
    methods: {}
}
</script>

<style scoped>
/* Aquí puedes meter tus sombras sutiles para el Neumorfismo */
</style>